import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { SharedReason } from '../../../core/models';

@Component({
  standalone: false,
  selector: 'pptl-select-drop-down',
  templateUrl: './select-drop-down.component.html',
  styleUrls: ['./select-drop-down.component.scss'],
})
export class SelectDropDownComponent {
  @Input() reasons: SharedReason[];
  @Output() selected = new EventEmitter<string>();
  @Output() valid = new EventEmitter();

  selectFormGroup: FormGroup;
  reason = '';
  textarea = '';
  isOpen = false;
  maxCharacters = 75;

  constructor(private formBuilder: FormBuilder) {
    this.selectFormGroup = this.formBuilder.group({
      reasonsInput: ['', Validators.compose([Validators.required, Validators.minLength(3)])],
      reasonTextarea: ['', Validators.compose([Validators.minLength(3)])],
    });

    this.selectFormGroup.valueChanges.subscribe(() => {
      this.isValid();
    });
  }

  select(reason: string): void {
    if (reason === 'input') {
      this.reason = this.textarea;
      this.selected.emit(this.reason);
      return;
    }
    this.reason = reason;
    this.selected.emit(this.reason);
    this.isOpen = false;
  }

  inputText(ev): void {
    this.reason = ev.target.value;
    this.textarea = ev.target.value;
    this.selected.emit(this.reason);
  }

  toggleSelect(): void {
    this.isOpen = !this.isOpen;
  }

  isValid(): void {
    this.valid.emit(
      !!this.selectFormGroup.controls.reasonsInput.value ||
        !!this.selectFormGroup.controls.reasonTextarea.value,
    );
  }

  isError(controlName: string, errorType: string): boolean {
    const control: AbstractControl = this.selectFormGroup.get(controlName);
    const controlHasError = control.hasError(errorType);

    return controlHasError && (control.dirty || control.touched);
  }

  getClass(controlName: string, errorType: string): string {
    return this.isError(controlName, errorType) || this.isError(controlName, 'required')
      ? 'error'
      : 'valid';
  }
}
